export function formatSourceLabel(raw) {
  if (raw === undefined || raw === null) return '';
  const s = String(raw).replace(/_/g, ' ').trim();
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Unique human-readable source names for a feed result row. */
export function getResultSourceList(res) {
  const seen = new Set();
  const names = [];

  const push = (raw) => {
    const label = formatSourceLabel(raw);
    if (!label) return;
    const key = label.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    names.push(label);
  };

  if (Array.isArray(res?.sources)) {
    res.sources.forEach((s) => push(s));
  }

  const rawSource = res?.source;
  if (typeof rawSource === 'string' && rawSource.trim()) {
    if (/[,+]/.test(rawSource)) {
      rawSource.split(/[,+]/).forEach((part) => push(part));
    } else {
      push(rawSource);
    }
  }

  if (names.length === 0) {
    if (res?.source_display_name) push(res.source_display_name);
    else if (res?.platform) push(res.platform);
    else if (rawSource) push(rawSource);
  }

  return names;
}

export function hasMultipleSources(res) {
  return getResultSourceList(res).length > 2;
}

export function getSourceAttributionLabel(res) {
  const sources = getResultSourceList(res);
  if (sources.length > 2) {
    return { label: 'Multiple Sources', sources, isMultiple: true };
  }
  if (sources.length === 2) {
    return { label: sources.join(' · '), sources, isMultiple: false };
  }
  if (sources.length === 1) {
    return { label: sources[0], sources, isMultiple: false };
  }
  return { label: '', sources: [], isMultiple: false };
}
